<template>
  <div class="sub-page">
    <div class="header">
      <van-nav-bar :title="$t('my.my_statement')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
        </template>
      </van-nav-bar>
      <div class="info">
        <p class="title">{{ $t("my.detail") }}({{ $t("reservation.unit") }})</p>
        <p class="value">{{ balanceText }}</p>
      </div>
    </div>

    <div class="datalist card">
      <div class="datalistitem">
        <div class="datalistitemValue">{{ personalreport.play_money || 0 }}</div>
        <div class="datalistitemKey">{{ $t("withdraw.task_money") }}</div>
      </div>
      <div class="datalistitem">
        <div class="datalistitemValue">{{ personalreport.recharge || 0 }}</div>
        <div class="datalistitemKey">{{ $t("withdraw.recharge_money") }}</div>
      </div>
      <div class="datalistitem">
        <div class="datalistitemValue">{{ personalreport.withdrawal || 0 }}</div>
        <div class="datalistitemKey">{{ $t("withdraw.money") }}</div>
      </div>
      <div class="datalistitem">
        <div class="datalistitemValue">{{ personalreport.win_money || 0 }}</div>
        <div class="datalistitemKey">{{ $t("withdraw.win_money") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      win_money: 0,
      personalreport: {},
    };
  },
  computed: {
    balanceText() {
      const n = Number(this.win_money);
      return Number.isFinite(n) ? n.toFixed(2) : "0.00";
    },
  },
  methods: {
    back() {
      return window.history.back();
    },
    getPersonalreport() {
      this.$http({ method: "get", url: "user_get_personalreport" }).then((res) => {
        if (res.code === 200) {
          this.personalreport = res.data || {};
          this.win_money =
            (this.personalreport.win_money || 0) -
            (this.personalreport.play_money || 0);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getPersonalreport();
    }
  },
};
</script>

<style lang="less" scoped>
.sub-page {
  min-height: 100vh;
  background: #000000;
}
.header {
  background: #c9a84c;
  padding-bottom: 40px;
}
.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 10px;
}
.info .title {
  margin: 0;
  font-size: 26px;
  color: hsla(0, 0%, 100%, 0.85);
}
.info .value {
  margin: 16px 0 0;
  color: #fff;
  font-size: 56px;
  font-weight: 700;
}
.card {
  background: #141414;
  border-radius: 16px;
  margin: -20px 24px 24px;
  box-shadow: 0 4px 16px rgba(128, 121, 237, 0.12);
}
.datalist {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
}
.datalistitem {
  width: 50%;
  height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.datalistitemValue {
  color: #c9a84c;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 10px;
}
.datalistitemKey {
  color: #979799;
  font-size: 26px;
}
</style>
